import { useContext, useEffect, useState } from "react";
import { Box, Flex, Link, Spacer, IconButton, Button, Menu, MenuButton, MenuList, MenuItem, MenuOptionGroup } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FiLogOut } from "react-icons/fi";
import AuthContext from "../contexts/AuthContext";
import axios from "axios";
import { useCompany } from "../contexts/CompanyContext";


const Navbar = () => {
  const { logout, getToken } = useContext(AuthContext);
  const [companies, setCompanies] = useState([]);
  const { selectedCompany, setSelectedCompany } = useCompany();

  useEffect(() => {
    axios.get('/api/companies', {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }).then(response => {
      if (response.status === 200) {
        const companiesArr = response.data;
        setCompanies(companiesArr);
        if (companiesArr.length > 0) {
          if(!selectedCompany || !companiesArr.some(company => company.company_id === selectedCompany.company_id)) {
            // If no company is selected or the selected company is not in the list, set the first company as selected
            setSelectedCompany(companiesArr[0]);
          }
        }
      } else {
        console.error("Error retrieving user companies:", response.data);
      }
    }).catch((error) => {
      if (error.status === 409) {
        console.error("No companies found for the user.");

        // Check if we already are in the home page
        if (window.location.pathname !== '/home') {
          window.location.href = '/home';
        }
      } else {
        console.error("Error retrieving user companies2: ", error);
      }
    });
  }, []);

  return (
    <Box as="nav" bg="teal.500" color="white" px={4} py={2} position="sticky" top={0} zIndex={1000}>
      <Flex alignItems="center">
        <Link href="/dashboard" fontSize="lg" fontWeight="bold" mr={4}>
          Dashboard
        </Link>

        <Spacer />

        <Menu>

          <MenuButton mr={4} as={Button} colorScheme='teal.500' rightIcon={<ChevronDownIcon />}>
            {selectedCompany ? selectedCompany.name : "Select Company"}
          </MenuButton>
          <MenuList type="radio">
            <MenuOptionGroup type="radio">
              {companies && companies.map((company) => (
              <MenuItem
                key={company.company_id}
                onClick={() => setSelectedCompany(company)}
                color="black"
                _hover={{ bg: "teal.100", color: "teal.700" }}
                _selected={{ bg: "teal.200", color: "teal.900" }}
              >
                {company.name}
              </MenuItem>
            ))}
            </MenuOptionGroup>
          </MenuList>
        </Menu>

        <IconButton
          aria-label="Logout"
          icon={<FiLogOut />}
          onClick={logout}
          variant="ghost"
          colorScheme="whiteAlpha"
          _hover={{ bg: "teal.600" }}
        />
      </Flex>
    </Box>
  );
};

export default Navbar;